import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const InstagramFeed = () => {
  const [dataProfile, setDataProfile] = useState({});

  const iconOpenNewTab = "/images/icon/ic-link-new-tab.svg";
  const iconReels = "/images/icon/ic-video-reels.svg";

  useEffect(() => {
    getInstagramData().then((res) => {
      setDataProfile(res);
    });
  }, []);

  return (
    <>
      <div className="block w-full">
        <div className="flex flex-wrap">
          {dataProfile?.data?.slice(0, 4).map((item) => (
            <div className="w-1/2" key={item.id}>
              <Link
                to={item.permalink}
                target="_blank"
                className="w-full h-full relative pb-[100%] block"
              >
                <img
                  src={
                    item.media_type === "VIDEO"
                      ? item.thumbnail_url
                      : item.media_url
                  }
                  alt={item.caption ?? "Image Feed"}
                  className="w-full h-full object-cover object-center absolute z-0"
                  loading="lazy"
                />
                <img
                  src={item.media_type === "VIDEO" ? iconReels : iconOpenNewTab}
                  alt=""
                  className="absolute w-[16px] h-[16px] top-4 right-4 z-1"
                  loading="lazy"
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export const getInstagramData = async () => {
  // const token =
  //   "IGQVJYdzYtTWJlZAzNoUHJ2SnU2NDJWOF85NHFrWmRnWDZAvTHVWUzc1SHlSYlZAKcHZAHbUdxNkdfYmtCWkNYSmNVZAnRGQ1gtVjFFU2gxUDlPU0JvcS0zbDc1Ums3Rk1SQnlTWF84UlZAnYzRWSzJ3U3JuTwZDZD";
  // const token = "EAADZAJNLK8voBOxCBVQItR9nUDPZCwcAOZCNeDdtJ5wNamKaN5oCqnm0xqrFSzEiYOerO75JuvpYU9kXkAHlf0sld0Pr3le5osnZCxTxuhyDyQrzoXH7ZBjAhV53GQZA8FqJBWPOxkadQtuuSTCXuO4nDOdKXL8D1bx3GrHvgNCSybdSSGHydq8QJPlFymc4y39gasGc6wZAgkZCU2FRiv5lLLzIzv7x8e4v9ZBxYzhiteJS7gGAD8fQTE9tEaXRIsmJQOg59ZCAILvg8ZD";
  const token =
    "EAADZAJNLK8voBO4T43ZCxfHJWBo9ZCmViAZAjm5eZBvS0PIWRFmfcqgYHmaSCvCmvEdzsLFnUlObxpMQKWp3hcqZBBCjiKYcVcZA2ziCa6nw8ZAeDbFrz0JNn6wAbOXE8uGx53T1y2BZCiZBiH0MfI1teMM5dP3vozxZBsAlyWGgtz61nc7iI0TXlTJVuYuRmtZBomMmUthuZCIx8";
  const url = `https://graph.instagram.com/me/media?fields=id,caption,media_url,media_type,thumbnail_url,timestamp,media_types,permalink&access_token=${token}`;

  const data = await fetch(url);
  const feed = await data.json();

  const promise = new Promise((resolve, reject) => {
    resolve(feed);
    reject(new Error("Cant get the data"));
  });

  return promise;
};

export default memo(InstagramFeed);
